import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Home from "./pages/front/home/Home";
import Chart from "./pages/front/chart/Chart";
import AuthLayout from "./layouts/auth/AuthLayout";
import FreeAuthRoute from "./routes/FreeAuthRoute";
import { ProtectedRoute } from "./routes/ProtectedRoute";
import ForgotPassword from "./pages/auth/ForgotPassword";
import PageNotFound from "./pages/PageNotFound";
import Dashboard from "./pages/admin/dashboard/Dashboard";
import CompanyList from "./pages/admin/companies/CompanyList";
import EmployeeList from "./pages/admin/employees/EmployeeList";
import AdminLayout from "./layouts/auth/AdminLayout";
import AdminList from "./pages/admin/admins/AdminList";
import EmailTemplate from "./pages/admin/email-template/EmailTemplate";
import AdminLogin from "./pages/admin/signIn/AdminLogin";
import ManageCompany from "./pages/admin/companies/ManageCompany";
import EditProfile from "./pages/admin/profile/EditProfile";
import ManageEmailTemplate from "./pages/admin/email-template/ManageEmailTemplate";
import ManageAdmin from "./pages/admin/admins/ManageAdmin";
import EmployeeDetails from "./components/sections/front/directory/EmployeeDetails";
import AdminCompanyDetails from "./pages/admin/companies/AdminCompanyDetails";
import Departments from "./components/sections/front/directory/DepartmentSection";
import Positions from "./components/sections/front/directory/PositionSection";
import Company from "./pages/front/company/CompanyDetails";
import MyProfile from "./pages/front/profile/MyProfile";
import Employees from "./components/sections/front/directory/EmployeeSection";
import EmployeesTable from "./components/sections/front/directory/EmployeeTableSection";
import Signin from "./pages/front/signin/Signin";
import AcceptAdministrator from "./pages/auth/AcceptAdministrator";
import FrontPasswordChange from "./pages/front/profile/FrontPasswordChange";
import Calendar from "./pages/front/calendar/Calendar";
import AcceptEmployee from "./pages/auth/AcceptEmployee";
import SettingsPage from "./pages/admin/settings/SettingsPage";
import Authentication from "./pages/Authentication";
import BuyPlan from "./pages/front/plan/BuyPlan";
import ShareChart from "./pages/front/shareChart.js/ShareChart";
import FilledPositionSection from "./components/sections/front/directory/FilledPosition";
import ResearchChart from "./pages/front/chart/ResearchChart";
import ChartTwo from "./pages/front/chart/ChartTwo";
import HierarchyChart from "./pages/front/chart/HierarchyChart";
import TestChart from "./pages/TestChart";

const authRoutes = [
  { path: "/signin", title: "Sign In", element: <Signin /> },
  { path: "/admin/signin", title: "Admin Login", element: <AdminLogin /> },
  {
    path: "/forgotPassword",
    title: "Forgot Password",
    element: <ForgotPassword />,
  },
  {
    path: "/accept-administrator",
    title: "Accept Administrator",
    element: <AcceptAdministrator />,
  },
  {
    path: "/accept-employee",
    title: "Accept Employee",
    element: <AcceptEmployee />,
  },
  {
    path: "/authentication",
    title: "Authentication",
    element: <Authentication />,
  },
];

const frontRoutes = [
  {
    path: "/",
    // component: <Chart />,
    component: <ChartTwo />,
    getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
    isLayout: true,
  },
  {
    path: "/hierarchyChart",
    component: <TestChart />,
    getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
    isLayout: true,
  },
  {
    path: "/researchChart",
    component: <ResearchChart />,
    // component: <HierarchyChart />,
    // component: <ChartTwo />,

    getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
    isLayout: true,
  },
  // {
  //   path: "/demo",
  //   component: <HierarchyChart />,
  //   getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
  //   isLayout: true,
  // },
  // {
  //   path: "/home",
  //   component: <Home />,
  //   getAccess: ["COMPANY-ADMINISTRATOR"],
  // },
  // {
  //   path: "/directory",
  //   component: <Employees />,
  //   getAccess: ["COMPANY-ADMINISTRATOR"],
  // },
  // {
  //   path: "/employees",
  //   component: <Employees />,
  //   getAccess: ["COMPANY-ADMINISTRATOR"],
  //   isLayout: true,
  // },
  {
    path: "/employees",
    component: <EmployeesTable />,
    getAccess: ["COMPANY-ADMINISTRATOR"],
    isLayout: true,
  },
  {
    path: "/employees/:id",
    component: <EmployeeDetails />,
    getAccess: ["COMPANY-ADMINISTRATOR"],
    isLayout: true,
  },
  {
    path: "/change-password",
    component: <FrontPasswordChange />,
    getAccess: ["COMPANY-ADMINISTRATOR"],
    isLayout: true,
  },
  {
    path: "/departments",
    component: <Departments />,
    getAccess: ["COMPANY-ADMINISTRATOR"],
    isLayout: true,
  },
  {
    path: "/filledpositions",
    component: <FilledPositionSection />,
    getAccess: ["COMPANY-ADMINISTRATOR"],
    isLayout: true,
  },
  {
    path: "/vacantpositions",
    component: <Positions />,
    getAccess: ["COMPANY-ADMINISTRATOR"],
    isLayout: true,
  },
  // {
  //   path: "/calendar",
  //   component: <Calendar />,
  //   getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
  // },
  { path: "/profile", component: <MyProfile />, isLayout: true },
  // {
  //   path: "/company",
  //   component: <Company />,
  //   getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
  //   isLayout: true,
  // },
  {
    path: "/buy-plan",
    component: <BuyPlan />,
    getAccess: ["COMPANY-ADMINISTRATOR", "COMPANY-MANAGER"],
    isLayout: false,
  },
];

const adminRoutes = [
  { path: "/admin/dashboard", component: <Dashboard /> },
  { path: "/admin", component: <Dashboard /> },
  { path: "/admins", component: <AdminList /> },
  { path: "/admin/add", component: <ManageAdmin /> },
  { path: "/admin/edit/:id", component: <ManageAdmin /> },
  { path: "/admin/companies", component: <CompanyList /> },
  { path: "/admin/company/add", component: <ManageCompany /> },
  { path: "/admin/company/edit/:id", component: <ManageCompany /> },
  { path: "/admin/company/details/:id", component: <AdminCompanyDetails /> },
  { path: "/admin/employees", component: <EmployeeList /> },
  { path: "/admin/email-template", component: <EmailTemplate /> },
  { path: "/admin/site-settings", component: <SettingsPage /> },
  { path: "/admin/profile", component: <EditProfile /> },
  {
    path: "/admin/email-template/edit/:id",
    component: <ManageEmailTemplate />,
  },
];

const CreateRoutes = () => (
  <BrowserRouter>
    <ScrollToTop>
      <Routes>
        {authRoutes.map(({ path, title, element }) => (
          <Route
            key={path}
            path={path}
            element={<FreeAuthRoute title={title}>{element}</FreeAuthRoute>}
          />
        ))}

        {frontRoutes.map(({ path, component, getAccess, isLayout }) => (
          <>
            {isLayout ? (
              <Route key={path} path={path} element={<AuthLayout />}>
                <Route
                  path={path}
                  element={
                    <ProtectedRoute getAccess={getAccess}>
                      {component}
                    </ProtectedRoute>
                  }
                />
              </Route>
            ) : (
              <Route
                path={path}
                element={
                  <ProtectedRoute getAccess={getAccess}>
                    {component}
                  </ProtectedRoute>
                }
              />
            )}
          </>
        ))}

        {adminRoutes.map(({ path, component }) => (
          <Route key={path} path={path} element={<AdminLayout />}>
            <Route
              path={path}
              exact
              element={
                <ProtectedRoute getAccess={["ADMIN"]}>
                  {component}
                </ProtectedRoute>
              }
            />
          </Route>
        ))}

        <Route
          path="/admin"
          element={
            <ProtectedRoute getAccess={["ADMIN"]}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route path="/share/chart" element={<ShareChart />} />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </ScrollToTop>
  </BrowserRouter>
);

export default CreateRoutes;
